function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useRef, useCallback, useEffect } from 'react';
import { withTheme } from '../../core/theming';
import Text, { TextType } from '../Typography/Text';
import { View, TouchableOpacity, FlatList, StyleSheet, Platform } from 'react-native';
import Badge from '../Badge';

const Tabs = _ref => {
  let {
    style,
    values = [],
    selectedIndex = 0,
    theme: {
      colors,
      isRTL
    },
    onChange
  } = _ref;
  const flatListRef = useRef(null);
  useEffect(() => {
    if ((values === null || values === void 0 ? void 0 : values.length) > selectedIndex) {
      var _flatListRef$current;

      flatListRef === null || flatListRef === void 0 ? void 0 : (_flatListRef$current = flatListRef.current) === null || _flatListRef$current === void 0 ? void 0 : _flatListRef$current.scrollToIndex({
        animated: true,
        index: selectedIndex,
        viewPosition: 0.5
      });
    }
  }, [selectedIndex, values]);
  const renderItemBadge = useCallback(badge => {
    return /*#__PURE__*/React.createElement(Badge, badge);
  }, []);
  const renderItem = useCallback(_ref2 => {
    let {
      item,
      index
    } = _ref2;
    return /*#__PURE__*/React.createElement(View, {
      style: {
        justifyContent: 'center'
      }
    }, /*#__PURE__*/React.createElement(TouchableOpacity, _extends({
      accessibilityRole: onChange ? 'button' : undefined
    }, item === null || item === void 0 ? void 0 : item.accessibility, {
      style: [styles.itemButton, {
        backgroundColor: index === selectedIndex ? colors.line.light : 'transparent'
      }],
      onPress: () => onChange && onChange(index)
    }), /*#__PURE__*/React.createElement(Text, {
      type: TextType.Body
    }, item.name), item.badge && renderItemBadge(item.badge)));
  }, [onChange, selectedIndex, colors, renderItemBadge]);
  return /*#__PURE__*/React.createElement(View, {
    style: [{
      minHeight: 56,
      backgroundColor: colors.background.white
    }, style]
  }, /*#__PURE__*/React.createElement(FlatList, {
    contentContainerStyle: styles.flatlist,
    horizontal: true,
    showsHorizontalScrollIndicator: false,
    ref: flatListRef,
    data: values || [],
    keyExtractor: item => item.name,
    renderItem: renderItem,
    onScrollToIndexFailed: () => console.log('scrollToIndex Error') // This is needed to fix bug with wrong index on iOS when RTL
    // direction is only for iOS, so no need to check Android
    ,
    style: isRTL && {
      direction: 'ltr'
    },
    inverted: isRTL && Platform.OS === 'ios'
  }));
};

const styles = StyleSheet.create({
  flatlist: {
    justifyContent: 'center',
    minWidth: '100%',
    padding: 8
  },
  itemButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    height: 40,
    borderRadius: 20
  }
});
export default withTheme(Tabs);
//# sourceMappingURL=RoundTabs.js.map